<template>
  <button class="btn btn-transparent px12 w-100 fs gap4" v-bind="$attrs">
    <img
        :alt="market?.market_full_name"
        :src="getImageFromProxy(`${imagesUrl}${market?.logo_name}`, '50:50')"
        height="20"
        width="20"
    />
    <UiPrice :price="price" class="white fw600" />
    <slot />
  </button>
</template>

<script lang="ts" setup>
import {getImageFromProxy} from "~/utils/get-image-url";
import UiPrice from "~/components/ui/Price.vue";

const props = defineProps<{
  market?: any;
  price?: number;
}>();

const config = useRuntimeConfig();
const imagesUrl = config.public.imagesUrl;
</script>
